import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SupplyCheckRecipientContactsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SupplyCheckRecipientContactsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const supplyCheckRecipientContacts = (
  request: SupplyCheckRecipientContactsRequest,
  options?: CashRequestOptions
) =>
  post<SupplyCheckRecipientContactsRequest, SupplyCheckRecipientContactsResponse>(
    '/2.0/cash/supply-check-recipient-contacts',
    request,
    { ...options, rejectOnError: true }
  )
